module.exports = __webpack_public_path__ + "img/core.06c6e0cb.jpg";